import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import { selectMembersInStore, selectMembersPageLoading, selectMembersShowInitWaitingMessage } from '../_selectors/member.selectors';

export class MemberDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
	
		 //console.log('check -1111')

		this.loading$ = this.store.pipe(
			select(selectMembersPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectMembersShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectMembersInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.resultCount);
			this.entitySubject.next(response.list);
		});
	}
}
